import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import h from 'react-hyperscript';
import App from './js/App.js';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    h(Router, null, h(App, null, null)),
    document.getElementById('root')
);

serviceWorker.unregister();
